let DataTypes = {
	hash: {
		// List should be deserialized as an array
		// but is serialized in the hash store
		// as a simple string list: '1,2,3,4,5'
		list: {
			serialize: function (value = []) {
				let persistentList = '';
				if (value && value.length) {
					persistentList = value
						.map(val => {
							if (typeof val === 'string') {
								return encodeURIComponent(val);
							}

							return val;
						})
						.join(',');
				}
				return persistentList;
			},
			deserialize: function (value = '') {
				if (value && value.length) {
					try {
						// For lists of JS objects
						return JSON.parse('[' + value + ']');
					} catch (e) {
						// For lists of strings / invalid JSON
						return value.split(',').map(decodeURIComponent);
					}
				}
				return [];
			}
		},
		listOfNumbers: {
			serialize: function (value = []) {
				if (value && value.length) {
					return value.filter(val => !isNaN(Number(val))).join(',');
				}
				return '';
			},
			deserialize: function (value = '') {
				if (value && value.length) {
					return value
						.split(',')
						.map(Number)
						.filter(val => !isNaN(val));
				}
				return [];
			}
		},
		json: {
			serialize: function (value) {
				return JSON.stringify(value);
			},
			deserialize: function (value) {
				if (typeof value === 'string' && value.length === 0) {
					return '';
				}
				return JSON.parse(value);
			}
		},
		boolean: {
			serialize: function (value) {
				return String(value);
			},
			deserialize: function (value) {
				return value === 'true';
			}
		}
	}
};

module.exports = DataTypes;
